type StepIndicatorProps = {
	stepNumber: number;
	label: string;
	isActive?: boolean;
	isCompleted?: boolean;
	selectedValue?: string;
};

export function StepIndicator({
	stepNumber,
	label,
	isActive = false,
	isCompleted = false,
	selectedValue,
}: StepIndicatorProps) {
	const classes = [
		"pf-step-indicator",
		isActive ? "pf-step-indicator--active" : "",
		isCompleted ? "pf-step-indicator--completed" : "",
	]
		.filter(Boolean)
		.join(" ");

	const showSelected = isCompleted && selectedValue;

	return (
		<div className={classes}>
			<span className="pf-step-indicator__number">{stepNumber}</span>
			<div className="pf-step-indicator__content">
				<span className="pf-step-indicator__label">{label}</span>
				{showSelected ? (
					<span className="pf-step-indicator__selected">
						<strong>Selected:</strong> {selectedValue}
					</span>
				) : null}
			</div>
		</div>
	);
}
